import _ from "lodash";
import { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import InvoicesActionCell from "components/CustomCells/InvoicesActionCell";
import ToastUtils from "utils/ToastUtils";
import InvoiceHelpers from "utils/InvoiceHelpers";
import InvoicesStatusCell from "components/CustomCells/InvoicesStatusCell";

function InvoicesTable({ companyId = null, fromDate = null, toDate = null, setInvoiceSummaries }) {
  const [invoices, setInvoices] = useState([]);

  const columns = [
    { Header: "ΚΑΤΑΣΤΑΣΗ", accessor: "status", width: "5%" },
    { Header: "ΜΑΡΚ", accessor: "mark" },
    { Header: "ΣΕΙΡΑ", accessor: "series", width: "10%" },
    { Header: "Α.Α.", accessor: "aa", width: "10%" },
    { Header: "ΗΜΕΡΑ", accessor: "issueDate" },
    { Header: "ΩΡΑ ΚΛΗΣΗΣ", accessor: "timestamp" },
    { Header: "ΤΥΠΟΣ", accessor: "typeDescription" },
    { Header: "ΑΦΜ ΠΑΡΑΛΗΠΤΗ", accessor: "counterpartVatNumber" },
    { Header: "ΚΑΘΑΡΗ ΑΞΙΑ", accessor: "totalNetAmount" },
    { Header: "ΣΥΝΟΛΟ ΦΠΑ", accessor: "totalVatAmount" },
    { Header: "ΣΥΝΟΛΙΚΗ ΑΞΙΑ", accessor: "totalGrossAmount" },
    { Header: "ΕΝΕΡΓΕΙΕΣ", accessor: "actions" },
  ];

  const refreshInvoices = async () => {
    const response = await InvoiceHelpers.search(companyId, fromDate, toDate);

    if (!response) {
      ToastUtils.error("Αδυναμία αναζήτησης παραστατικών!");
      return;
    }

    ToastUtils.success("Επιτυχής αναζήτηση παραστατικών!");
    const invoices = response.data.data;
    invoices.map((e) => {
      e.status = <InvoicesStatusCell transmissionFailure={e.transmissionFailure} />;
      e.actions = <InvoicesActionCell invoice={e} />;
      const currentTimestamp = new Date(e.requestDate);
      e.timestamp = currentTimestamp
        .toLocaleString("en-GB", { timeZone: "Europe/Athens" })
        .replace(",", "");
    });
    setInvoices(response.data.data);
    const summaries = {
      clean: _.sumBy(invoices, "totalNetAmount"),
      vat: _.sumBy(invoices, "totalVatAmount"),
      gross: _.sumBy(invoices, "totalGrossAmount"),
      count: invoices.length,
    };
    setInvoiceSummaries(summaries);
  };

  useEffect(() => {
    if (!companyId || !fromDate || !toDate) return;
    refreshInvoices();
  }, [companyId, fromDate, toDate]);

  return (
    <DataTable
      table={{ rows: invoices, columns: columns }}
      entriesPerPage={{
        defaultValue: 10,
        entries: [10, 20, 50],
      }}
      canSearch
    />
  );
}

export default InvoicesTable;
